import React from 'lib/react';
import {
  EVGrid, EVPaper, EVTypography, makeStyles,
  EVCheckCircleOutlineIcon,
} from '@eagleview/ev-comp-library';
import { useTranslation } from 'lib/translation';
import { SUPPORT_ROUTE } from 'constants/RouteConstants';
import { Link } from 'lib/router';

const useStyles = makeStyles(() => ({
  accountsDeletionSuccessContainer: {
    display: 'flex',
    flex: '1 1 auto',
  },
  accountsDeletionSuccessPaper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    margin: '0px',
    padding: '24px',
    gap: '45px',
    width: '100%',
    '@media (min-width: 1024px)': {
      margin: '16px 24px 16px 24px',
      width: 'auto',
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '0px',
    '@media (min-width: 1024px)': {
      padding: '84px 0px',
    },
  },
  notifyIconText: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  notifyText: {
    fontWeight: 600,
    fontSize: '20px',
  },
  supportText: {
    fontSize: '16px',
    padding: '0px 29px 0px 32px',
    '@media (min-width: 1024px)': {
      padding: '0px',
    },
  },
  supportLink: {
    textDecoration: 'underline',
  },
}));

function AccountDeletionSuccessPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <EVGrid className={classes.accountsDeletionSuccessContainer}>
      <EVPaper className={classes.accountsDeletionSuccessPaper} elevation={0}>
        <EVGrid className={classes.textContainer}>
          <EVGrid className={classes.notifyIconText}>
            <EVCheckCircleOutlineIcon htmlColor="#288301" />
            <EVTypography className={classes.notifyText}>{t('accounts_deletion__success_notification')}</EVTypography>
          </EVGrid>
          <EVTypography className={classes.supportText}>
            {t('accounts_deletion__success_query_text')}
            {' '}
            <Link className={classes.supportLink} to={SUPPORT_ROUTE}>{t('accounts_deletion__support_page')}</Link>
          </EVTypography>
        </EVGrid>
      </EVPaper>
    </EVGrid>
  );
}

export default AccountDeletionSuccessPage;
